import { useTranslation } from "react-i18next";
import { ModalShell } from "@/shared/layout";
import { Modal } from "@/shared/ui";
import { AlertTriangle } from "@/shared/ui/icons";

export function UnsavedChangesModal({
  open,
  onCancel,
  onExit,
}: {
  open: boolean;
  onCancel: () => void;
  onExit: () => void;
}) {
  const { t } = useTranslation();
  const footer = (
    <>
      <button type="button" className="btn btn-secondary btn-sm" onClick={onCancel}>
        {t("changesModal.cancel")}
      </button>
      <button type="button" className="btn btn-error btn-sm" onClick={onExit}>
        {t("changesModal.exitWithoutSaving")}
      </button>
    </>
  );
  return (
    <Modal
      id="save-config-modal"
      open={open}
      onOpenChange={(next) => {
        if (!next) onCancel();
      }}
      title={t("changesModal.changesDetected")}
    >
      <ModalShell
        title={t("changesModal.changesDetected")}
        description={t("changesModal.unsavedChanges")}
        onClose={onCancel}
        footer={footer}
      >
        <div className="dw-modal-notice warning">
          <AlertTriangle aria-hidden="true" />
          <span>{t("changesModal.unsavedChanges")}</span>
        </div>
      </ModalShell>
    </Modal>
  );
}
